<template>
  <div id="app">
    <Album albumTitle="FRAIL"
           moreInfo="an album by Johan Doornenbal<br/>click on a turntable to enjoy a song in the old fashinoned way or visit on <a href='https://open.spotify.com/album/6katBkzwZMO2yar0VBYx4A?si=qXizymmcT_qBYsRoD33KLQ' target=_blank>spotify</a>"
    />
    <Songs/>
    <Credits/>
  </div>
</template>

<script>
import Album from './components/Album.vue'
import Credits from './components/Credits.vue'
import Songs from './components/Songs.vue'

export default {
  name: 'App',
  components: {
    Credits,
    Album,
    Songs
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

html, body {
  background-color: seashell;
}

* {
  box-sizing: border-box;
}

a:link, a:hover, a:visited, a:active {
  color: #2c3e50;
}
</style>
